import { render, staticRenderFns } from "./BtnSelecionarProduto.vue?vue&type=template&id=db5cd57c&"
import script from "./BtnSelecionarProduto.vue?vue&type=script&lang=js&"
export * from "./BtnSelecionarProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports